import React, { Component } from 'react';
// import styles from './RoomsTable.module.css'
// import Spinner from 'components/UI/Spinner/Spinner'
import { List, Input, Tooltip } from 'antd';

const { Item } = List;

class EditableList extends Component {
  state = {
    editable: false,
    showPopup: false,
    value: null,
  };

  onEditHandler = () => {
    const editable = !this.state.editable;
    this.setState(prev => ({ ...prev, editable }));
  };

  onCancelHandler = () => {
    const editable = !this.state.editable;
    this.setState(prev => ({
      ...prev,
      editable,
      value: null,
    }));
  };

  onInputChangeHandler = e => {
    const { value } = e.target;
    this.setState(prev => ({ ...prev, value: value }));
  };

  onUpdateHandler = value => {
    if (!value || value.length === 0) {
      this.setState(prev => ({ ...prev, showPopup: true }));
      return;
    }
    const data = { ...this.props.item };
    data['name'] = value;
    this.props
      .onUpdate(data)
      .then(this.setState(prev => ({ ...prev, editable: false })))
      .catch(console.error);
  };

  onDeleteHandler = value => {
    this.props
      .onDelete(value)
      .then(this.setState(prev => ({ ...prev, editable: false })))
      .catch(console.error);
  };

  renderEditState = () => {
    const { value } = this.state;
    const { item } = this.props;
    return (
      <Item
        actions={[
          <a onClick={() => this.onUpdateHandler(value)}>save</a>,
          <a onClick={this.onCancelHandler}>cancel</a>,
        ]}
      >
        <Tooltip placement="left" title="Input name" visible={this.state.showPopup}>
          <Input
            autoFocus
            value={value === null ? item.name : value}
            style={{ width: 200 }}
            onChange={this.onInputChangeHandler}
            onPressEnter={() => this.onUpdateHandler(value)}
          />
        </Tooltip>
      </Item>
    );
  };

  renderShowState = () => {
    const { item } = this.props;
    return (
      <Item
        actions={[<a onClick={this.onEditHandler}>edit</a>, <a onClick={() => this.onDeleteHandler(item)}>delete</a>]}
      >
        <strong>{item.name}</strong>
      </Item>
    );
  };

  render() {
    const { editable } = this.state;
    return editable ? this.renderEditState() : this.renderShowState();
  }
}

class RoomsList extends Component {
  renderListItem = item => {
    return <EditableList item={item} onDelete={this.props.onDelete} onUpdate={this.props.onUpdate} />;
  };

  renderList = () => {
    const { rooms, isLoading } = this.props;
    return <List loading={isLoading} bordered dataSource={rooms} renderItem={this.renderListItem} />;
  };

  render() {
    return this.renderList();
  }
}

export default RoomsList;



// WEBPACK FOOTER //
// ./src/components/Rooms/RoomsList.js